import { PublicationSectionContainer } from './PublicationSection.container';
import * as React from 'react';

import { PublicationLayout } from '../PublicationLayout/PublicationLayout';

export const PublicationSection = () => {
  return <PublicationLayout content={<PublicationSectionContainer />} />;
};
